import React, { useState, useImperativeHandle, forwardRef, useEffect, useRef } from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import Button from '@material-ui/core/Button'

//helpers
import Api from '../../../../__helpers/api'

//images
import closeIcon from '../../../../assets/images/profile/topic-info/close.png'

//actions
import { switchGroup } from '../../../../__actions/instructor'

//modals
import QuestionModal from '../../../modals/Question'

//dispatcher
import { useDispatch, useSelector } from 'react-redux'

function TransferStudent(props, ref) {
    const dispatch = useDispatch()

    const __state = useSelector(state => state)
    //
    const currentGroup = __state.instructorReducer.group?.current || ''

    const initialState = {
        currentGroup: null,
        id: null,
        changed: false
    }

    const [state, setState] = useState({
        blur: false,
        popup: false,
        data: [],
        loading: true,
        saveLoading: false,
        ...initialState
    })

    const questionModalRef = useRef(null)

    useImperativeHandle(ref, () => ({
        open: id => handleOpen(id),
        close: () => handleClose()
    }))

    const handleOpen = id => {
        document.querySelector('body').style.overflow = 'hidden'
        document.querySelector('html').style.overflow = 'hidden'

        setState(state => ({
            ...state,
            blur: true,
            id,
            currentGroup
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 50)
    }

    const handleClose = () => {
        document.querySelector('body').style.overflow = 'initial'
        document.querySelector('html').style.overflow = 'initial'

        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
                ...initialState
            }))
        }, 100)
    }

    useEffect(() => {
        loading(true)
        const theoryGroupsUrl = 'center/groups/list'

        Api.get(theoryGroupsUrl)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data,
                }))
            })
            .finally(() => {
                loading(false)
            })
    }, [state.popup])

    const handleChange = currentGroup => {
        setState(prev => ({
            ...prev,
            changed: true,
            currentGroup
        }))
    }

    const handleSave = () => {
        saveLoading(true)

        const url = 'center/students/move'

        Api.post(url, {
            user_id: state.id,
            group_id: state.currentGroup
        })
            .then(() => {
                dispatch(switchGroup(state.currentGroup))
                handleClose()
            })
            .finally(() => {
                saveLoading(false)
            })
    }

    const loading = loading => {
        setState(prev => ({
            ...prev,
            loading
        }))
    }

    const saveLoading = saveLoading => {
        setState(prev => ({
            ...prev,
            saveLoading
        }))
    }


    return (
        <div id="overlay" className={`transfer-student-overlay ${state.blur ? 'visible' : ''}`}>
            <QuestionModal
                ref={questionModalRef}
                mainMessage="Повърждавате ли възстановяването на тази група?"
                secondaryMessage="След потвърждение, ще виждате групата в основния екран."
            // handleConfirm={handleConfirmUnarhive}
            />
            <div className={`box transfer-student ${state.popup ? 'show' : ''}`}>
                <img
                    src={closeIcon}
                    className="close"
                    alt="Затваряне"
                    title="Затваряне"
                    onClick={handleClose}
                    style={{ filter: 'invert(65%) sepia(16%) saturate(313%) hue-rotate(154deg) brightness(91%) contrast(91%)' }}
                />
                <h3>
                    Трансфер на курсист
                </h3>
                <ul>
                    {state.data.map(group =>
                        <li
                            key={group.id}
                            className={group.id == state.currentGroup ? 'active' : ''}
                            onClick={() => handleChange(group.id)}
                        >
                            <div className="left">
                                <h6>
                                    {group.public_name}
                                </h6>
                                <h5>
                                    създадена на: <i className="date">дата?</i>
                                </h5>
                                <h5>
                                    брой курсисти: <i className="count">{group.acceptedstudents_count}</i>
                                </h5>
                            </div>
                        </li>
                    )}
                </ul>
                {state.saveLoading ?
                    '...'
                    :
                    <Button
                        className={!state.changed || state.currentGroup == currentGroup ? 'disabled' : ''}
                        onClick={handleSave}
                    >
                        Запазване
                    </Button>
                }
            </div>
        </div >
    )
}

export default forwardRef(TransferStudent)